import * as moment from 'moment';
import { setServiceDescription } from 'src/app/utils/set-service-description.utils';
import { DocumentStatusDto, MailMeSearchDto } from '../../interfaces';

export class CourrierScheduler {
  public dateEcheance;
  public dateEcheanceLabel: string;
  public objetFormated;
  public objetFormatedLabel: string;
  public typeEntrantSortant;
  public typeEntrantSortantLabel: string;
  public serviceProprietaire: { codeService: string; description: string; id: number; parentId: number };
  public serviceProprietaireLabel: string;

  constructor(
    data?: MailMeSearchDto & {
      objetFormated: string;
      statutIdLabel: string;
      statutDatas: {
        label: string;
        value: number;
        color: string;
        textColor: string;
        statut: DocumentStatusDto;
        ordre: number;
        globalStatutId: number;
        globalStatutName?: string;
      };
    }
  ) {
    Object.assign(this, data);

    this.dateEcheanceLabel = this.dateEcheance !== null ? moment(this.dateEcheance).format('DD/MM/YYYY') : 'Non renseignée';
    this.objetFormatedLabel = this.objetFormated !== null && this.objetFormated !== '' ? this.objetFormated : 'Non renseigné';
    this.typeEntrantSortantLabel = this.typeEntrantSortant === 'E' ? 'Entrant' : 'Sortant';
    this.serviceProprietaireLabel = this.serviceProprietaire.description;
  }
}
